/* tslint:disable */

declare var Object: any;
export interface StorageActivityInterface {
  "id"?: number;
}

export class StorageActivity implements StorageActivityInterface {
  "id": number;
  constructor(data?: StorageActivityInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StorageActivity`.
   */
  public static getModelName() {
    return "StorageActivity";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StorageActivity for dynamic purposes.
  **/
  public static factory(data: StorageActivityInterface): StorageActivity{
    return new StorageActivity(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StorageActivity',
      plural: 'StorageActivities',
      path: 'StorageActivities',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/StorageActivity.ts